import { LazyModule, createLazyComponent } from 'owa-bundling';
import { ComponentClass } from 'react';
import * as spItemsView from './lazyIndex';

const lazyModuleSPItemsView = new LazyModule<typeof spItemsView>(() =>
    import(/* webpackChunkName: "gfh-itemsview" */ './lazyIndex')
);

export const LazySPItemsViewCommandBar = createLazyComponent(
    lazyModuleSPItemsView,
    m => m.SharepointItemsViewCommandBar
);

export const LazySPItemsViewErrorComponent = createLazyComponent(
    lazyModuleSPItemsView,
    m => m.SharepointItemsViewErrorComponent
);

export const LazySPItemsViewList = createLazyComponent(
    lazyModuleSPItemsView,
    m => m.SharepointItemsViewList
);

export const LazySPItemsViewNavigator = createLazyComponent(
    lazyModuleSPItemsView,
    m => m.SharepointItemsViewNavigator
);

export const LazySPItemsViewRefreshComponent = createLazyComponent(
    lazyModuleSPItemsView,
    m => m.SharepointItemsViewRefreshComponent
);

export type __unused_declarations = ComponentClass;
